<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
    <Title :title="{name: '项目管理',path: '/system/project/all'}" :button-array="buttonArray" @exportExcel="exportExcel"></Title>
    <div style="margin: 10px auto;">
      <el-card class="box-card">
        <el-row :gutter="20" style="margin-left: 10px;">
          <el-col :span="5">
            <el-input v-model="qparam.projectIden" placeholder="项目编号"></el-input>
          </el-col>
          <el-col :span="5">
            <el-input v-model="qparam.managerName" placeholder="项目负责人"></el-input>
          </el-col>
          <el-col :span="9">
            <el-date-picker
              style=""
              v-model="applyTime"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-col>

        </el-row>
        <el-row :gutter="20" style="margin-left: 10px; margin-top: 10px">
          <el-col :span="8">
            <el-input v-model="qparam.projectName" placeholder="项目名字"></el-input>
          </el-col>
          <el-col :span="8">
            <el-input v-model="qparam.contractName" placeholder="合同名字"></el-input>
          </el-col>
          <el-col :span="8">
            <el-select v-model="qparam.projectState" placeholder="项目状态">
              <el-option
                  v-for="item in projectStateData"
                  :key="item.stateId"
                  :label="item.stateName"
                  :value="item.stateId"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="5" style="float: right;margin-top: 10px">
            <el-button icon="el-icon-refresh-left" type="primary" @click="resetQparam">重置</el-button>
            <el-button icon="el-icon-search" type="primary" @click="search">查询</el-button>
          </el-col>
        </el-row>
      </el-card>
    </div>

    <div style="margin: 10px auto;">
      <el-card class="box-card" style="min-height: 650px;">
        <el-table
          :data="tableData"
          style="width: 100%">
          <el-table-column
              prop="projectIden"
              label="项目立项编号"
              width="140px">
          </el-table-column>
          <el-table-column
            prop="projectName"
            label="项目名字">
          </el-table-column>
          <el-table-column
            prop="userName"
            label="申请人"
            width="120px">
          </el-table-column>
          <el-table-column
            prop="managerName"
            label="项目负责人"
            width="120px">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="申请时间"
            width="210px">
          </el-table-column>
          <el-table-column label="操作" width="210px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="handleDetail(scope.$index, scope.row)">查看项目
              </el-button>
              <el-button
                size="mini"
                type="info"
                v-if="user.roles.includes(1) || user.roles.includes(4)"
                @click="handleTransfer(scope.$index, scope.row)">转移项目
              </el-button>

            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 40px auto; width: 30%;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="currentPageChangeEvent"
            :current-page="qparam.current"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="qparam.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
          </el-pagination>
        </div>
      </el-card>
    </div>
    <el-dialog
      title="项目信息"
      :visible.sync="projectShow"
      width="1200px"
      top="6vh">
      <ProjectDialog :projectId="projectId" :key="uuid" :role="1"></ProjectDialog>
    </el-dialog>
    <el-dialog
      title="项目转移"
      :visible.sync="transferShow"
      width="30%">
      <div v-if="shifts.length>0">
        <el-divider content-position="left">项目转移记录</el-divider>
        <div v-for="item in shifts" style="margin-bottom: 5px">
          <div>转移前负责人: {{ item.orgManagerName }}</div>
          <div>转移后负责人: {{ item.nowManagerName }}</div>
          <div>转移时间: {{ item.createTime }}</div>
        </div>
      </div>
      <el-divider content-position="left">我要转移</el-divider>
      <el-form label-position="top">
        <el-form-item label="转移前负责人" prop="contractName">
          <el-input v-model="localManagerName" readonly></el-input>
        </el-form-item>
        <el-form-item label="转移后负责人" prop="newProjectManager">
          <el-select v-model="newProjectManager" placeholder="请选择项目负责人" filterable style="width: 100%" :popper-append-to-body="false">
            <el-option
              v-for="item in sysUserList"
              :key="item.userId"
              :label='item.realName'
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="transfer">开始转移</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>

import {mapState} from 'vuex';
import {requestAllProjectPage, requestOwnProjectPage, exportAllProject, requestProjectShiftRecord,
  requestShiftProjectManager, requestUserGet, requestProjectDetail} from "@/api";
import Title from "../../Title";
import ProjectDialog from "../common/ProjectDialog";
import {uuid, AesDecrypt} from "@/util";

export default {
  name: "AllApply",
  components: {Title, ProjectDialog},
  data() {
    return {
      projectShow: false,
      uuid: "",
      tableData: [],
      totalElements: 0,
      transferShow: false,
      localManagerName: "",
      newProjectManager: "",
      projectManager: "",
      sysUserList: [],
      shifts: [],
      qparam: {
        current: 1,
        size: 10,
        managerName: "",
        projectName: "",
        projectIden: "",
        startTime: "",
        endTime: "",
        contractName: "",
        projectState: ""
      },
      apply: {},
      applyTime: [],
      detailShow: false,
      projectId: "",
      buttonArray : [{
        type: 'primary',
        title: '导出',
        method: 'exportExcel',
        disabled: false,
      }],
      user: {},
      projectStateData: [
          { stateId: '1', stateName: '已沟通' },
          { stateId: '2', stateName: '已采购' },
          { stateId: '3', stateName: '已签约' },
          { stateId: '4', stateName: '已回款' },
          { stateId: '5', stateName: '已实施' },
          { stateId: '6', stateName: '项目终止'},
          { stateId: '7', stateName: '已完成' }
      ]
    }
  },
  computed: {
    ...mapState(['flowData'])
  },
  methods: {
    async loadSysUserData() {
      let res = await requestUserGet();
      if (res.code === 200) {
        this.sysUserList = res.object;
      } else {
        this.$message.error("获取人员列表失败")
      }
    },

    handleSizeChange(size) {
      this.qparam.current = 1;
      this.qparam.size = size;
      this.initTableData()
    },
    resetQparam() {
      this.applyTime = []
      this.qparam.managerName = ""
      this.qparam.projectName = ""
      this.qparam.projectIden = ""
      this.qparam.contractName = ""
      this.qparam.projectState = ""
      this.initTableData()
    },
    handleDetail(index, row) {
      this.projectShow = true
      this.projectId = row.projectId
      this.uuid = uuid()
    },
    currentPageChangeEvent(currentPage) {
      this.qparam.current = currentPage;
      this.initTableData()
    },
    async search() {
      this.qparam.current = 1
      await this.initTableData()
    },
    async initTableData() {
      this.qparam.startTime = this.applyTime[0]
      this.qparam.endTime = this.applyTime[1]
      if (this.user.roles.includes(1) || this.user.roles.includes(4)) {
        const res = await requestAllProjectPage(this.qparam);
        if (res.code === 200) {
          this.totalElements = res.total
          this.tableData = res.rows
        } else {
          this.$message.error(res.msg)
        }
      } else {
        const data = await requestOwnProjectPage(this.qparam);
        if (data.code === 200) {
          this.totalElements = data.total
          this.tableData = data.rows
        } else {
          this.$message.error(data.msg)
        }
      }
    },
    async exportExcel() {
      let param = {}
      if(this.qparam.createTimeArr && this.qparam.createTimeArr.length > 0){
        param.startTime = this.qparam.endTime
        param.endTime = this.qparam.startTime
      }
      param.managerName = this.qparam.managerName;
      param.projectIden = this.qparam.projectIden
      param.projectState = this.qparam.projectState

      const res = await exportAllProject(param);
      if (res.code === 200) {
        window.location.href = res.object
        this.$message.success(res.msg)
      } else {
        this.$message.error(res.msg)
      }
    },
    async transfer() {
      if (!this.newProjectManager) {
        this.$message.error("请选择新的项目负责人");
        return
      }
      const res = await requestShiftProjectManager({
        projectId: this.projectId,
        userId: this.newProjectManager,
      })
      if (res.code === 200) {
        this.$message.success(res.msg)
        this.getProjectShiftRecord(this.projectId)
        await this.getProjetInfo(this.projectId)
        this.newProjectManager = ""
      } else {
        this.$message.error(res.msg);
      }
    },
    getProjectShiftRecord(projectId) {
      requestProjectShiftRecord({
        projectId: projectId,
      }).then(res => {
        if (res.code === 200) {
          if (res.object) {
            this.shifts = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 项目转移
    handleTransfer(index, row) {
      this.projectId = row.projectId
      this.transferShow = true
      this.localManagerName = row.managerName
      this.loadSysUserData()
      this.getProjectShiftRecord(row.projectId)
      document.body.scrollTop = 0
    },
    getProjetInfo(id) {
      this.disabled = false
      requestProjectDetail({projectId: id}).then(res => {
        if (res.code === 200) {
          if (res.object) {
            let detail = res.object.detail
            this.localManagerName = detail.managerName
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
  },
  created() {
    let data = AesDecrypt(window.localStorage.getItem("user"));
    this.user = JSON.parse(data);
    this.initTableData()
  }
}
</script>

<style scoped>

</style>
